import { render, staticRenderFns } from "./SettingQuestion.vue?vue&type=template&id=4ece69ea&scoped=true&"
import script from "./SettingQuestion.vue?vue&type=script&lang=js&"
export * from "./SettingQuestion.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/setting.css?vue&type=style&index=0&id=4ece69ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece69ea",
  null
  
)

export default component.exports